import Mutations from '../../odata/mutations';

export default { ...new Mutations('currencyItem'), ...new Mutations('currencyItems') };
